import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/components/Layout.vue'
// import { WORK_DETAIL_ROUTE } from '@/enums/report.js'

Vue.use(Router)

// 解决在子应用时，点父应用的路由跳转不生效的问题
// const hook = (target, name, before, after) => {
//   if (!target) return
//   const origin = target[name]
//   target[name] = (...args) => {
//     try {
//       before && before(...args)
//     } catch (e) {
//       console.log(e)
//     }
//     const result = origin.call(target, ...args)
//     try {
//       after && after(...args)
//     } catch (e) {
//       console.log(e)
//     }
//     return result
//   }
//   return () => {
//     target[name] = origin
//   }
// }
// hook(window.history, 'replaceState', null, (state, _, url) => {
//   window.location.replace(url)
// })
// hook(window.history, 'pushState', null, (state, _, url) => {
//   window.location.replace(url)
// })

const componentWarp = url => {
  return () => import(/* webpackChunkName: "[request]" */ '@/views/' + url + '.vue')
}

export const routes = [
  {
    path: '/home',
    name: '/home',
    component: componentWarp('partner'),
    meta: {
      icon: 'iconfont associate-menu-home',
      title: '首页',
    },
  },
  {
    path: '/staff',
    meta: {
      icon: 'iconfont associate-menu-staff',
      title: '员工管理',
    },
    component: Layout,
    children: [
      {
        path: 'list',
        name: '/staff/list',
        meta: {
          title: '员工列表',
        },
        component: componentWarp('staff/staff-list'),
      },
      {
        path: 'employ/list',
        name: '/staff/employ/list',
        meta: {
          title: '人员管理',
        },
        component: componentWarp('partner'),
      },
      {
        path: 'employ/add',
        name: '/staff/employ/add',
        meta: {
          title: '添加员工',
          hideMenu: true,
        },
        component: componentWarp('partner'),
      },
      {
        path: 'employ/detail',
        name: '/staff/employ/detail',
        meta: {
          title: '查看用工信息',
          hideMenu: true,
        },
        component: componentWarp('partner'),
      },
      {
        path: 'employ/edit',
        name: '/staff/employ/edit',
        meta: {
          title: '修改用工信息',
          hideMenu: true,
        },
        component: componentWarp('partner'),
      },
      {
        path: 'personinfo/edit',
        name: '/staff/personinfo/edit',
        meta: {
          title: '修改个人信息',
          hideMenu: true,
        },
        component: componentWarp('partner'),
      },
      {
        path: 'attendance',
        name: '/staff/attendance',
        meta: {
          title: '考勤明细',
        },
        component: componentWarp('staff/attendance'),
      },
      {
        path: 'crew-schedule',
        name: '/staff/crew-schedule',
        meta: {
          title: '员工排班',
        },
        component: componentWarp('shift-management'),
      },
      {
        path: 'crew-schedule-v2',
        name: '/staff/crew-schedule-v2',
        meta: {
          title: '新员工排班',
        },
        component: componentWarp('shift-management'),
      },
      {
        path: 'crew-location',
        name: '/staff/crew-location',
        meta: {
          title: '员工位置上报',
        },
        component: componentWarp('shift-management'),
      },
    ],
  },
  {
    path: '/staff-t0',
    meta: {
      icon: 'iconfont associate-menu-staff',
      title: 'T0人员管理',
    },
    component: Layout,
    children: [
      // 个人
      {
        path: 'personal-info/list',
        name: '/staff-t0/personal-info/list',
        meta: {
          title: '个人信息',
        },
        component: componentWarp('staff-management'),
      },
      {
        path: 'personal-info/detail',
        name: '/staff-t0/personal-info/detail',
        meta: {
          title: '个人信息详情',
          hideMenu: true,
        },
        component: componentWarp('staff-management'),
      },
      {
        path: 'personal-info/config',
        name: '/staff-t0/personal-info/config',
        meta: {
          title: '个人信息编辑',
          hideMenu: true,
        },
        component: componentWarp('staff-management'),
      },
      // 人员工种
      {
        path: 'worktype-config',
        name: '/staff-t0/worktype-config',
        meta: {
          title: '人员工种',
        },
        component: componentWarp('staff-management'),
      },
      // 用工
      {
        path: 'employment-management',
        name: '/staff-t0/employment-management',
        meta: {
          title: '用工信息',
        },
        component: componentWarp('staff-management'),
      },

      {
        path: 'employment-management/edit',
        name: '/staff-t0/employment-management/edit',
        meta: {
          title: '用工信息编辑/新增',
          hideMenu: true,
        },
        component: componentWarp('staff-management'),
      },

      {
        path: 'employment-management/detail',
        name: '/staff-t0/employment-management/detail',
        meta: {
          title: '用工信息详情',
          hideMenu: true,
        },
        component: componentWarp('staff-management'),
        children: [
          {
            path: 'log',
            name: '/staff-t0/employment-management/detail/log',
            meta: {
              title: '用工信息变更记录',
              hideMenu: true,
            },
            component: componentWarp('staff-management'),
          },
          {
            path: 'info',
            name: '/staff-t0/employment-management/detail/info',
            meta: {
              title: '用工信息详情基础信息',
              hideMenu: true,
            },
            component: componentWarp('staff-management'),
          },
        ],
      },
    ],
  },
  // {
  //   path: '/operation',
  //   meta: {
  //     icon: 'iconfont associate-menu-city',
  //     title: '运营管理',
  //   },
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'geofence',
  //       name: '/operation/geofence',
  //       meta: {
  //         title: '地理围栏',
  //       },
  //       component: componentWarp('operation/geofence'),
  //     },
  //   ],
  // },
  // athena
  {
    path: '/athena',
    name: '/athena',
    component: Layout,
    meta: {
      icon: 'iconfont associate-menu-city',
      title: '运营管理',
    },
    children: [
      {
        path: 'lbs/geoFence',
        name: '/athena/lbs/geoFence',
        meta: {
          title: '围栏编辑',
        },
        component: componentWarp('athena'),
      },
      {
        path: 'lbs/geoFenceOperationHistory/list',
        name: '/athena/lbs/geoFenceOperationHistory/list',
        meta: {
          title: '编辑历史',
        },
        component: componentWarp('athena'),
      },
      {
        path: 'lbs/geoFenceOperationHistory/view',
        name: '/athena/lbs/geoFenceOperationHistory/view',
        meta: {
          title: '编辑历史',
          hideMenu: true,
        },
        component: componentWarp('athena'),
      },
    ],
  },
  {
    path: '/task',
    meta: {
      icon: 'iconfont associate-task-management',
      title: '任务中心',
    },
    component: Layout,
    children: [
      {
        path: 'list',
        name: '/task/list',
        meta: {
          title: '任务列表',
        },
        component: componentWarp('task'),
      },
      {
        path: 'detail',
        name: '/task/detail',
        meta: {
          title: '任务详情',
          hideMenu: true,
        },
        component: componentWarp('task'),
      },
    ],
  },
  {
    path: '/data',
    meta: {
      icon: 'iconfont associate-menu-data',
      title: '数据看板',
    },
    component: Layout,
    children: [
      {
        path: 'business-daily-report',
        name: '/data/business-daily-report',
        meta: {
          title: '经营日报',
        },
        component: componentWarp('polaris-report'),
      },
      {
        path: 'daily',
        name: '/data/daily',
        meta: {
          title: '经营专项',
        },
        component: componentWarp('partner'),
      },
      {
        path: 'income',
        name: '/data/income',
        meta: {
          title: '收入专项',
        },
        component: componentWarp('partner'),
      },
      {
        path: 'monthly-report',
        name: '/data/monthly-report',
        meta: {
          title: '诊断月报',
        },
        component: Layout,
        children: [
          {
            path: 'preview',
            name: '/data/monthly-report/preview',
            meta: {
              title: '月报查看',
            },
            component: componentWarp('partner'),
          },
          {
            path: 'preview/detail',
            name: '/data/monthly-report/preview/detail',
            meta: {
              title: '月报详情',
              hideMenu: true,
            },
            component: componentWarp('partner'),
          },
        ],
      },
      {
        path: 'assets',
        meta: {
          title: '资产专项',
        },
        component: Layout,
        children: [
          {
            path: 'spock-panel',
            name: '/data/assets/spock-panel',
            meta: {
              title: '电单车看板',
            },
            component: componentWarp('partner'),
          },
          {
            path: 'spock-panel-detail',
            name: '/data/assets/spock-panel-detail',
            meta: {
              title: '电单车明细',
              hideMenu: true,
            },
            component: componentWarp('partner'),
          },
          {
            path: 'battery-panel-v2',
            name: '/data/assets/battery-panel-v2',
            meta: {
              title: '电池看板',
            },
            component: componentWarp('partner'),
          },
          {
            path: 'battery-panel-detail',
            name: '/data/assets/battery-panel-detail',
            meta: {
              title: '电池明细',
              hideMenu: true,
            },
            component: componentWarp('partner'),
          },
          {
            path: 'loss',
            name: '/data/assets/loss',
            meta: {
              title: '车电资损',
            },
            component: componentWarp('partner'),
          },
        ],
      },
      {
        path: 'dispatch-panel',
        name: '/data/dispatch-panel',
        meta: {
          title: '调度专项',
        },
        component: componentWarp('partner'),
      },
      {
        path: 'dispatch',
        meta: {
          title: '调度其他',
        },
        component: Layout,
        children: [
          {
            path: 'schedule-order',
            name: `/data/dispatch/schedule-order`,
            meta: {
              title: '调度作业明细-工单维度',
            },
            component: componentWarp('data/work-detail'),
          },
          {
            path: 'schedule-bike',
            name: `/data/dispatch/schedule-bike`,
            meta: {
              title: '调度作业明细-车辆维度',
            },
            component: componentWarp('data/work-detail'),
          },
          {
            path: 'point-level',
            name: `/data/dispatch/point-level`,
            meta: {
              title: '调度点位评级',
            },
            component: componentWarp('partner'),
          },
          {
            path: 'point-in',
            name: `/data/dispatch/point-in`,
            meta: {
              title: '调入点位推荐',
            },
            component: componentWarp('data/dipatch-recommend'),
          },
          {
            path: 'point-out',
            name: `/data/dispatch/point-out`,
            meta: {
              title: '调出点位推荐',
            },
            component: componentWarp('data/dipatch-point-out'),
          },
          {
            path: 'profit',
            name: `/data/dispatch/profit`,
            meta: {
              title: '调度收益分析',
            },
            component: componentWarp('data/dipatch-profit'),
          },
        ],
      },
      {
        path: 'intervene',
        meta: {
          title: '干预专项',
        },
        component: Layout,
        children: [
          {
            path: 'fault-car',
            name: '/data/intervene/fault-car',
            meta: {
              title: '故障处理看板',
            },
            component: componentWarp('partner'),
          },
          {
            path: 'schedule-intervene',
            name: '/data/intervene/schedule-intervene',
            meta: {
              title: '干预作业',
            },
            component: componentWarp('partner'),
          },
        ],
      },
      {
        path: 'change-battery',
        name: '/data/change-battery',
        meta: {
          title: '换电专项',
        },
        component: componentWarp('partner'),
      },
      {
        path: 'schedule-retrieve',
        name: '/data/schedule-retrieve',
        meta: {
          title: '寻回作业',
        },
        component: componentWarp('data/work-detail'),
      },
      {
        path: 'user-operation',
        name: '/data/user-operation',
        meta: {
          title: '用户运营',
        },
        component: componentWarp('partner'),
      },
      {
        path: 'user-experience',
        name: '/data/user-experience',
        meta: {
          title: '用户体验',
        },
        component: componentWarp('partner'),
      },
      {
        path: 'city',
        meta: {
          title: '城市经营数据',
        },
        component: Layout,
        children: [
          {
            path: 'joint-partner',
            name: '/data/city/joint-partner',
            meta: {
              title: '联营/代理合作商',
            },
            component: componentWarp('data/joint-partner'),
          },
          {
            path: 'consulter-partner',
            name: '/data/city/consulter-partner',
            meta: {
              title: '经营咨询合作商',
            },
            component: componentWarp('data/consulter-partner'),
          },
        ],
      },
      {
        path: 'bike-compus',
        name: '/data/bike-compus',
        meta: {
          title: '单车校园运营数据',
        },
        component: componentWarp('partner'),
      },
      {
        path: 'bike-consult',
        name: '/data/bike-consult',
        meta: {
          title: '单车合作商经营数据',
        },
        component: componentWarp('partner'),
      },
      {
        path: 'order-pay-detail',
        name: '/data/order-pay-detail',
        meta: {
          title: '订单明细',
        },
        component: componentWarp('partner'),
      },
    ],
  },
  {
    path: '/perf',
    meta: {
      icon: 'iconfont associate-menu-pref',
      title: '绩效考核',
    },
    component: Layout,
    children: [
      {
        path: 'assessment',
        name: '/perf/assessment',
        meta: {
          title: '考核方案',
        },
        component: componentWarp('perf/assessment'),
      },
      {
        path: 'detail',
        name: '/perf/detail',
        meta: {
          title: '绩效明细',
        },
        component: componentWarp('perf/detail'),
      },
    ],
  },
  {
    path: '/assess',
    meta: {
      title: '绩效考核',
      icon: 'iconfont associate-menu-pref',
    },
    component: Layout,
    children: [
      {
        name: '/assess/kpi-overview',
        path: 'kpi-overview',
        meta: {
          title: '绩效总览',
        },
        component: componentWarp('partner'),
      },
      {
        name: '/assess/results',
        path: 'results',
        meta: {
          title: '考核结果',
        },
        component: componentWarp('assessment'),
      },
      {
        name: '/assess/detail',
        path: 'detail',
        meta: {
          title: '考核明细',
        },
        component: componentWarp('assessment'),
      },
      {
        path: 'kpi',
        name: '/assess/kpi',
        meta: {
          title: '绩效目标',
        },
        component: componentWarp('partner'),
      },
      {
        path: 'kpi-detail',
        name: '/assess/kpi-detail',
        meta: {
          title: '提报单查看',
          hideMenu: true,
        },
        component: componentWarp('partner'),
      },
    ],
  },
  {
    path: '/level',
    meta: {
      title: '等级权益',
      icon: 'iconfont associate-quanyikadanchuangzujian',
    },
    component: Layout,
    children: [
      {
        name: '/level/equity',
        path: 'equity',
        meta: {
          title: '权益详情',
        },
        component: componentWarp('partner'),
      },
    ],
  },
  {
    path: '/dispatching-subsidy',
    meta: {
      title: '合作商补贴',
      icon: 'iconfont associate-sqti-sqti-meal_taxi_fund_home',
    },
    component: Layout,
    children: [
      {
        name: '/dispatching-subsidy/detail',
        path: 'detail',
        meta: {
          title: '调度补贴明细',
        },
        component: componentWarp('assessment'),
      },
    ],
  },
  {
    path: '/invoice',
    meta: {
      title: '用户开票',
      icon: 'iconfont associate-mticon-fapiao-char',
    },
    component: Layout,
    children: [
      {
        name: '/invoice/list',
        path: 'list',
        meta: {
          title: '处理用户开票申请',
        },
        component: componentWarp('partner'),
      },
    ],
  },
  {
    path: '/bill',
    meta: {
      icon: 'iconfont associate-menu-bill',
      title: '账单列表',
    },
    component: Layout,
    children: [
      {
        path: 'day-detail',
        name: '/bill/day-detail',
        meta: {
          title: '日薪资明细',
        },
        component: componentWarp('bill/day-detail'),
      },
      {
        path: 'new-salary-manage/bill/salary-data-import',
        name: '/bill/new-salary-manage/bill/salary-data-import',
        meta: {
          title: '商费用导入',
        },
        component: componentWarp('bill/fee-import'),
      },
      {
        path: 'month-check',
        name: '/bill/month-detail',
        meta: {
          title: '月账单确认',
        },
        component: componentWarp('bill/month-detail'),
      },
      {
        path: 'reconcileBillQuery',
        name: '/bill/reconcileBillQuery',
        meta: {
          title: '对账单查询',
        },
        component: componentWarp('reconcileBill/reconcileBillQuery'),
      },
      {
        path: 'reconcileBillDetail',
        name: '/bill/reconcileBillDetail',
        meta: {
          title: '对账单详情',
          hideMenu: true,
        },
        component: componentWarp('reconcileBill/reconcileBillDetail'),
      },
      {
        path: 'account',
        name: '/bill/account',
        meta: {
          title: '账户查询',
        },
        component: componentWarp('person-price'),
      },
      {
        path: 'settlement',
        name: '/data/settlement',
        meta: {
          title: '结费数据',
        },
        component: componentWarp('data/settlement'),
      },
      {
        path: 'exclusiveBill',
        name: '/bill/exclusiveBill',
        meta: {
          title: '专属车辆对账单',
        },
        component: componentWarp('reconcileBill/exclusiveBill'),
      },
    ],
  },
  {
    path: '/invoice-management',
    meta: {
      icon: 'iconfont associate-menu-bill',
      title: '账单中心',
    },
    component: Layout,
    children: [
      {
        name: '/invoice-management/billConfirm',
        path: 'billConfirm',
        component: componentWarp('statement/billConfirm'),
        meta: {
          title: '平台账单',
        },
      },
      {
        name: '/invoice-management/billConfirm/detail',
        path: 'billConfirm/detail',
        component: componentWarp('statement/detail'),
        meta: {
          title: '平台账单详情',
          hideMenu: true,
        },
      },
      {
        name: '/invoice-management/cost-details-list',
        path: 'cost-details-list',
        component: componentWarp('person-price'),
        meta: {
          title: '费用明细',
        },
      },
      {
        name: '/invoice-management/agent-fee-detail',
        path: 'agent-fee-detail',
        component: componentWarp('partner'),
        meta: {
          title: '费用明细-代理费用',
        },
      },
      {
        name: '/invoice-management/bill-confirm',
        path: 'bill-confirm',
        meta: {
          title: '费用单',
        },
        component: componentWarp('person-price'),
      },
      {
        name: '/invoice-management/bill-confirm/expense/detail',
        path: 'bill-confirm/expense/detail',
        meta: {
          title: '费用确认单详情',
          hideMenu: true,
        },
        component: componentWarp('person-price'),
      },
      {
        name: '/invoice-management/bill-confirm/revenue/detail',
        path: 'bill-confirm/revenue/detail',
        meta: {
          title: '流水分成确认单详情',
          hideMenu: true,
        },
        component: componentWarp('person-price'),
      },
      {
        name: '/invoice-management/channel-invoice-list',
        path: 'channel-invoice-list',
        component: componentWarp('person-price'),
        meta: {
          title: '联营账单',
        },
      },
      {
        name: '/invoice-management/channel-invoice-detail',
        path: 'channel-invoice-detail',
        component: componentWarp('person-price'),
        meta: {
          title: '联营账单-详情',
          hideMenu: true,
        },
      },
      {
        name: '/invoice-management/distribute-money-manage',
        path: 'distribute-money-manage',
        component: componentWarp('person-price'),
        meta: {
          title: '分账管理',
        },
      },
    ],
  },
  {
    path: '/statement',
    component: Layout,
    meta: {
      icon: 'iconfont associate-klfont-bill',
      title: '对账单管理',
    },
    children: [
      {
        name: '/statement/account-list',
        path: 'account-list',
        component: componentWarp('person-price'),
        meta: {
          title: '费项账户查询',
        },
      },
    ],
  },
  {
    path: '/srm',
    meta: {
      icon: 'iconfont associate-menu-bill',
      title: '单车供应商中心',
    },
    component: Layout,
    children: [
      {
        path: 'bill-day',
        name: '/srm/bill-day',
        component: componentWarp('srm/bill-day'),
        meta: {
          title: '对账明细',
        },
      },
      {
        path: 'bill-detail',
        name: '/srm/bill-detail',
        component: componentWarp('srm/bill-detail'),
        meta: {
          title: '结算账单明细详情',
          hideMenu: true,
        },
      },
      {
        path: 'settlement-bill',
        name: '/srm/settlement-bill',
        component: componentWarp('srm/settlement-bill'),
        meta: {
          title: '对账单查询',
        },
      },
      {
        path: 'settlement-bill-detail',
        name: '/srm/settlement-bill-detail',
        component: componentWarp('srm/settlement-bill-detail'),
        meta: {
          title: '对账单详情',
          hideMenu: true,
        },
      },
      {
        path: 'pay-ahead',
        name: '/srm/pay-ahead',
        component: componentWarp('srm/pay-ahead'),
        meta: {
          title: '提前付款',
        },
      },
    ],
  },
  {
    path: '/daxue',
    meta: {
      icon: 'iconfont associate-icon--kecheng',
      title: '骑行学院',
    },
    component: Layout,
    children: [
      {
        path: 'personal',
        name: '/daxue/personal',
        component: componentWarp('partner'),
        meta: {
          title: '学院首页',
        },
      },
      {
        path: 'learn-plan',
        name: '/daxue/learn-plan',
        component: componentWarp('partner'),
        meta: {
          title: '学习中心',
        },
      },
      {
        path: 'course-center',
        name: '/daxue/course-center',
        component: componentWarp('partner'),
        meta: {
          title: '课程中心',
        },
      },
    ],
  },
  {
    path: '/mall',
    meta: {
      icon: 'iconfont associate-shangcheng',
      title: '商城',
    },
    component: Layout,
    children: [
      {
        path: 'list',
        name: '/mall/list',
        meta: {
          title: '商品列表',
        },
        component: componentWarp('mall/index'),
      },
      {
        path: 'list/detail',
        name: '/mall/list/detail',
        meta: {
          title: '商城列表购物车',
          hideMenu: true,
        },
        component: componentWarp('mall/index'),
      },
      {
        path: 'order',
        name: '/mall/order',
        meta: {
          title: '订单查询',
        },
        component: componentWarp('mall/index'),
      },
      {
        path: 'order-detail',
        name: '/mall/order-detail',
        meta: {
          title: '订单详情',
          hideMenu: true,
        },
        component: componentWarp('mall/index'),
      },
    ],
  },
  {
    path: '/message',
    component: Layout,
    meta: {
      icon: 'iconfont associate-menu-about',
      title: '消息管理',
    },
    children: [
      {
        name: '/message/view',
        path: 'view',
        component: componentWarp('message'),
        meta: {
          title: '消息中心',
        },
      },
      {
        name: '/message/view/detail',
        path: 'view/detail',
        meta: {
          title: '消息详情',
          hideMenu: true,
        },
        component: componentWarp('message'),
      },
    ],
  },
  {
    path: '/service',
    component: Layout,
    meta: {
      icon: 'iconfont associate-qcs-service',
      title: '服务中心',
    },
    children: [
      {
        name: '/service/feedback',
        path: 'feedback',
        component: componentWarp('partner'),
        menuURL: 'https://tt.sankuai.com/ticket/moses-helper?rgId=10604',
        newOpen: true,
        meta: {
          title: '问题反馈',
        },
      },
      {
        name: '/service/evaluation-list',
        path: 'evaluation-list',
        component: componentWarp('partner'),
        meta: {
          title: '服务评价',
        },
      },
      {
        name: '/service/evaluation-issue',
        path: 'evaluation-issue',
        component: componentWarp('partner'),
        meta: {
          title: '评价问卷',
          hideMenu: true,
        },
      },
    ],
  },
  {
    path: '/cooperate',
    component: Layout,
    meta: {
      icon: 'iconfont associate-mticon-cooperation',
      title: '合作信息',
    },
    children: [
      {
        name: '/cooperate/rate',
        path: 'rate',
        component: componentWarp('partner'),
        meta: {
          title: '开票税率',
        },
      },
    ],
  },
  {
    path: '/about',
    name: '/about',
    meta: {
      icon: 'iconfont associate-icon-stjrcp-lxrxx',
      title: '联系我们',
    },
    component: componentWarp('about'),
  },
  { path: '*', redirect: { name: '/home' } },
]

export default new Router({
  mode: 'history',
  base: '/associate',
  routes,
})
